import { getAccountStorage, getQueryString, setAccountStorage, setTokenStorage } from './../../../../utils/'
import { observable, action, runInAction } from "mobx";
import { getLabel } from '@weapp/utils';
import { Dialog, Empty } from '@weapp/ui';
import * as API from "../../../../api/pc/tenantInfo";

const { message } = Dialog;

export class TeamsStore {

  @observable currentView: string = 'index';//当前视图
  @observable applySendVisible: boolean = false;//申请
  @observable emailUserInfo: string = '';//更新
  @observable currentAccount: string = getAccountStorage() || '';
  @observable showEmptyPage: boolean = true;//白屏

  @action
  init = () => {
    this.currentAccount = getAccountStorage() || '';
    if (getQueryString('token')) {
      setTokenStorage(getQueryString('token'));
    }
    //是否邮件回调
    if (getQueryString('urlKey')) {
      API.emailCallback({ shortKey: getQueryString('urlKey') }).then((result: any) => {
        if (result?.data?.errorMsg) {
          const msg = result?.data?.errorMsg;
          message({
            type: "error",
            content: getLabel(msg.i18nId, msg.msg)
          })
        } else {
          runInAction(() => {
            if (result.data?.userInfo) {
              const e_account = result.data.userInfo.account || result.data.userInfo.email
              this.currentAccount = e_account
              setAccountStorage(e_account)
            }
            if (result.data?.token) {
              setTokenStorage(result.data?.token);
            }
            if (result.data?.redirectUrl) {
              window.location.href = result.data?.redirectUrl;
              return;
            }
          });
        }
        runInAction(() => {
          this.showEmptyPage = false;
        });
      })
    } else {
      this.showEmptyPage = false;
    }
  }
  @action
  reset = () => {
    this.currentView = 'index';
  }

  @action
  updateCurrentView = (view: string) => {
    this.currentView = view;
    this.applySendVisible = false;
  }
  @action
  changeApplySendVisible = (visible: boolean) => {
    this.applySendVisible = visible;
  }






}
const instance = new TeamsStore();

export default instance;
export type TeamsStoreType = Pick<TeamsStore, keyof TeamsStore>;
